import { render, staticRenderFns } from "./BlobFrame.vue?vue&type=template&id=40ca32ed&scoped=true&"
import script from "./BlobFrame.vue?vue&type=script&lang=js&"
export * from "./BlobFrame.vue?vue&type=script&lang=js&"
import style0 from "./BlobFrame.vue?vue&type=style&index=0&id=40ca32ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca32ed",
  null
  
)

export default component.exports